import { IsDateString, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class CostCentreDto extends BaseDto {
  @IsNumber()
  id: number;

  @IsNumber()
  @IsOptional()
  merchantGroupId?: number;

  @IsString()
  name: string;

  @IsDateString()
  startDate?: Date;

  @IsDateString()
  endDate?: Date;

  @IsString()
  @IsOptional()
  location?: string

  @IsString()
  address?: string;

  merchantGroup?: MerchantGroupDto;
  managerUser?: MerchantDto[];
  POSAutoLogout?: boolean;
  POSInactivityTimeoutSeconds?: number;
  costCentreLink?: string;
  isHeadOffice?: boolean;
}